import { render, staticRenderFns } from "./RightDetail.vue?vue&type=template&id=7305e31b&scoped=true"
import script from "./RightDetail.vue?vue&type=script&lang=js"
export * from "./RightDetail.vue?vue&type=script&lang=js"
import style0 from "./RightDetail.vue?vue&type=style&index=0&id=7305e31b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7305e31b",
  null
  
)

export default component.exports